var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarksReport24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 0.5H4.495C3.945 0.5 3.5 0.95 3.5 1.5H8.5C9.05 1.5 9.5 1.95 9.5 2.5V9L10.5 9.5V1.5C10.5 0.95 10.05 0.5 9.5 0.5ZM7.5 3.5V9.985L5.395 9.08L5 8.91L4.605 9.08L2.5 9.985V3.5H7.5ZM2.5 2.5H7.5C8.05 2.5 8.5 2.95 8.5 3.5V11.5L5 10L1.5 11.5V3.5C1.5 2.95 1.95 2.5 2.5 2.5Z",
    fill: "#878889"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarksReport24Px);
export default __webpack_public_path__ + "static/media/bookmarks_report_24px.95652eadb2415b9fe0a83710ff83daa1.svg";
export { ForwardRef as ReactComponent };